import { render, staticRenderFns } from "./dealerManage.vue?vue&type=template&id=3b2f0d4b&scoped=true&"
import script from "./dealerManage.vue?vue&type=script&lang=js&"
export * from "./dealerManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f0d4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b2f0d4b')) {
      api.createRecord('3b2f0d4b', component.options)
    } else {
      api.reload('3b2f0d4b', component.options)
    }
    module.hot.accept("./dealerManage.vue?vue&type=template&id=3b2f0d4b&scoped=true&", function () {
      api.rerender('3b2f0d4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/dealerManage/dealerManage.vue"
export default component.exports